import Address from "api/types/Address";

const useFormatAddress = () => ({
	formatAddressShort: (address: Address): string => {
		return [address.address1, address.address2, address.address3, address.city, address.state, address.postalCode]
			.filter(Boolean)
			.join(", ");
	}
});

export default useFormatAddress;
